import React, { useState } from "react";
import styled from "styled-components";

const RecruitManager = () => {
  const [jobs, setJobs] = useState([
    {
      id: 1,
      title: "Front-end Developer",
      date: "2026-04-20",
      status: "채용중",
    },
    { id: 2, title: "IT Manager (경력)", date: "2026-04-18", status: "마감" },
  ]);

  return (
    <TableContainer>
      <Table>
        <thead>
          <tr>
            <th>공고 제목</th>
            <th>등록일</th>
            <th>상태</th>
            <th>관리</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((job) => (
            <tr key={job.id}>
              <td>{job.title}</td>
              <td>{job.date}</td>
              <td>
                <StatusBadge active={job.status === "채용중"}>
                  {job.status}
                </StatusBadge>
              </td>
              <td>
                <EditBtn>수정</EditBtn>
                <DelBtn>삭제</DelBtn>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
  );
};

const TableContainer = styled.div`
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;
const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  th,
  td {
    padding: 1.2rem 2rem;
    border-bottom: 1px solid #f1f5f9;
  }
  th {
    background: #f8fafc;
    font-weight: 600;
    color: #64748b;
    font-size: 0.9rem;
  }
`;
const StatusBadge = styled.span`
  padding: 0.3rem 0.6rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${(props) => (props.active ? "#dcfce7" : "#fee2e2")};
  color: ${(props) => (props.active ? "#166534" : "#991b1b")};
`;
const EditBtn = styled.button`
  margin-right: 1rem;
  color: #2563eb;
  border: none;
  background: none;
  cursor: pointer;
`;
const DelBtn = styled.button`
  color: #ef4444;
  border: none;
  background: none;
  cursor: pointer;
`;

export default RecruitManager;
